import React, { HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';
import constants from '../common/theme/constants';

const DEFAULT_COLUMN_WIDTH = '22rem';

const Grid = styled.div<{ columnWidth: string; gap: number }>`
  @media all and (min-width: 48rem) {
    grid-template-columns: repeat(auto-fill, ${({ columnWidth }) => columnWidth});
  }
  display: grid;
  grid-gap: ${({ gap }) => gap}px;
`;

const GridList = styled.ul<{ columnWidth: string; gap: number }>`
  @media all and (min-width: 48rem) {
    grid-template-columns: repeat(auto-fill, ${({ columnWidth }) => columnWidth});
  }
  display: grid;
  grid-gap: ${({ gap }) => gap}px;
  list-style: none;
  margin-block: unset;
  margin-inline: unset;
  padding-inline: unset;
`;

export interface KitGridProps extends HTMLAttributes<HTMLDivElement | HTMLUListElement> {
  className?: string;
  children: ReactNode;
  columnWidth?: string;
  gap?: number;
}

const KitGrid: React.FC<KitGridProps> = ({
  className,
  children,
  columnWidth = DEFAULT_COLUMN_WIDTH,
  gap = constants.spacing.absolute.m,
  ...rest
}: KitGridProps) => {
  if (rest.role === 'list') {
    return (
      <GridList className={className} columnWidth={columnWidth} gap={gap} {...rest}>
        {children}
      </GridList>
    );
  }

  return (
    <Grid className={className} columnWidth={columnWidth} gap={gap} {...rest}>
      {children}
    </Grid>
  );
};

export default KitGrid;
